import React from "react";
import { Typography } from "@material-ui/core";
import { TranslationJSX } from "../../utils/Translation";
import { SearchListNullContainer } from "./style";

const SearchListNull = () => (
  <SearchListNullContainer>
    <Typography variant="body2">
      <TranslationJSX locoKey="feed_search_no_result" />
    </Typography>
  </SearchListNullContainer>
);

export default SearchListNull;
